import React, { useEffect, useRef, useState } from 'react';
import { Redirect } from 'react-router-dom';
import { Link as RouterLink } from 'react-router-dom';
import {
    Avatar,
    Box,
    ButtonBase,
    Menu,
    MenuItem,
    makeStyles,
} from '@material-ui/core';
import useAuth from 'src/hooks/useAuth';
import { useTranslation } from 'react-i18next';
import useNotification from 'src/hooks/useNotification';
import getInitials from 'src/utils/getInitials';
import { isPermissionGranted } from 'src/utils/permissions/isPermissionGranted';
import {
    CREATE_PERMISSION,
    IMPERSONATE_USER_AUTH,
} from 'src/constants/permissions';

const useStyles = makeStyles(() => ({
    avatar: {
        height: 45,
        width: 45,
    },
    popover: {
        minWidth: 200,
        width: 'content',
    },
}));

const Account = () => {
    const classes = useStyles();
    const ref = useRef(null);
    const { t } = useTranslation();
    const { user } = useAuth();
    const [isOpen, setOpen] = useState(false);
    const { clearNotificationState } = useNotification();
    const canImpersonate = isPermissionGranted({
        permissions: user?.permissions || {},
        permission: IMPERSONATE_USER_AUTH,
        crud: CREATE_PERMISSION,
    });

    const { logout } = useAuth();
    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleLogout = () => {
        let lenguaje = localStorage.getItem('language');
        let menu = localStorage.getItem('typeMenu');
        let lan = localStorage.getItem('i18nextLng');
        let token = localStorage.getItem('token');
        let settings = localStorage.getItem('settings');

        localStorage.clear();

        localStorage.setItem('language', lenguaje);
        localStorage.setItem('typeMenu', menu);
        localStorage.setItem('i18nextLng', lan);
        localStorage.setItem('token', token);
        localStorage.setItem('settings', settings);

        logout();
    };

    useEffect(() => {
        return () => clearNotificationState();
        //eslint-disable-next-line
    }, []);

    if (!localStorage.getItem('token')) {
        return <Redirect to="/" />;
    }

    return (
        <>
            <Box
                display="flex"
                alignItems="center"
                component={ButtonBase}
                onClick={handleOpen}
                ref={ref}
            >
                <Avatar
                    alt={user?.name || ''}
                    className={classes.avatar}
                    src={`https://automotive-api.s3.us-east-2.amazonaws.com/${
                        user?.image || ''
                    }`}
                >
                    {getInitials(user?.name || '')}
                </Avatar>
            </Box>
            <Menu
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                keepMounted
                PaperProps={{ className: classes.popover }}
                getContentAnchorEl={null}
                anchorEl={ref.current}
                open={isOpen}
            >
                <MenuItem component={RouterLink} to="/account">
                    {t('Account.Account')}
                </MenuItem>

                {canImpersonate && (
                    <MenuItem
                        component={RouterLink}
                        to="/management/impersonation"
                    >
                        Accesos temporales
                    </MenuItem>
                )}

                <MenuItem onClick={handleLogout}>
                    {t('Account.Logout')}
                </MenuItem>
            </Menu>
        </>
    );
};

export default Account;
